import { Link } from "react-router-dom";
import { BadgeCheck } from "lucide-react";

export function Brand({ dark = false }) {
  return (
    <Link to="/" data-testid="brand-logo-link" className="flex items-center gap-2.5">
      <div className="w-9 h-9 rounded-xl bg-blue-600 flex items-center justify-center shadow-sm">
        <BadgeCheck className="w-5 h-5 text-white" />
      </div>
      <div className="leading-tight">
        <span className={`block font-heading font-bold text-base ${dark ? "text-white" : "text-slate-900"}`}>Equinox 4 Review</span>
        <span className={`block text-[10px] font-medium tracking-wide ${dark ? "text-slate-400" : "text-slate-500"}`}>EQUINOX4REVIEW.IN</span>
      </div>
    </Link>
  );
}
